import { Atom, atom } from 'jotai'

export interface Stage {
  id: number
  name: string
  ename: string
  description: string
}

export const stagesAtom: Atom<Stage[]> = atom([])
